import { Alert } from "@mantine/core";
import { Outlet } from "react-router-dom";
import { useAuthStore } from "../../../store";
import { canReviewLegacyReports } from "../../../utils/legacyCaseAccess";

export default function LegacyReportReviewGuard() {
  const profile = useAuthStore((state) => state.profile);
  if (!canReviewLegacyReports(profile))
    return (
      <Alert color="red" title="Report review access required">
        Historical reconstruction is available to archive administrators and
        authorized clinical reviewers.
      </Alert>
    );
  return <Outlet />;
}
